import {
  LOCATION_ACTIVE_COUNTRIES,
  LOCATION_CITIES,
  LOCATION_CITY,
} from "shared/constants/apiUrls";

import { get } from "./axios";

/**
 * Get city data by country iso code and city id if it set
 * @param {string} countryCode Country iso code
 * @param {string | undefined} cityId Id of search city
 * @returns {Promise<AxiosResponse<*>>}
 */
export function getCity(countryCode, cityId = null) {
  const query =
    "?country_code=" + countryCode + (cityId ? "&city_id=" + cityId : "");

  return get(import.meta.env.VITE_APP_API_HOST + LOCATION_CITY + query);
}

/**
 * Get cities list for selected country
 *
 * @returns {AxiosPromise<any>}
 */
export function getCities(countryCode, cityText) {
  const query =
    "?country_code=" + countryCode + (cityText ? "&city=" + cityText : "");
  return get(import.meta.env.VITE_APP_API_HOST + LOCATION_CITIES + query);
}

/**
 * Get countries list
 *
 * @returns {AxiosPromise<any>}
 */
export function getCountries() {
  return get("/assets-v2/countries.json");
  //return get(import.meta.env.VITE_APP_API_HOST + LOCATION_COUNTRIES);
}

/**
 * Get active countries list
 *
 * @returns {AxiosPromise<any>}
 */
export function getActiveCountries() {
  return get(import.meta.env.VITE_APP_API_HOST + LOCATION_ACTIVE_COUNTRIES);
}
